import React, { useCallback, useLayoutEffect } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { useCart } from '../../hooks';
import { DeliveryCustomization } from './components';

// ────────────────────────────────────────────────────────────────────────────────

export const CustomizationDeliveryEditScreen = () => {
  const router = useRouter();
  const routeParams = useLocalSearchParams<CustomizationDeliveryEditScreenRouteParams>();

  const { addressId, productSlug, lineItemId } = routeParams;

  const { cart } = useCart();

  // ─────────────────────────────────────────────────────────────────

  const navigateToBag = useCallback(() => {
    try {
      router.dismissTo('/bag');
    } catch {
      // expo-router throws if called before Root Layout mounts
    }
  }, [router]);

  const navigateToCustomizationDelivery = useCallback(() => {
    try {
      router.replace({
        pathname: '/delivery/[addressId]/[productSlug]',
        params: {
          addressId: addressId ?? '',
          productSlug: productSlug ?? '',
        },
      });
    } catch {
      // expo-router throws if called before Root Layout mounts
    }
  }, [addressId, router, productSlug]);

  // ─────────────────────────────────────────────────────────────────

  // redirect to the delivery customization screen if the line item isn't in the cart or has been removed
  useLayoutEffect(() => {
    const lineItems = cart?.lineItems;
    const isLineItemInCart = lineItems?.some(({ id }) => id === lineItemId);

    if (isLineItemInCart) return;

    navigateToCustomizationDelivery();
  }, [cart?.lineItems, lineItemId, navigateToCustomizationDelivery]);

  // ─────────────────────────────────────────────────────────────────

  return (
    <DeliveryCustomization
      addressId={addressId}
      productSlug={productSlug}
      lineItemId={lineItemId}
      isEditProductMode={true}
      onEditLineItemInCart={navigateToBag}
      onRemoveLineItemFromCart={navigateToBag}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationDeliveryEditScreenRouteParams = {
  addressId: string;
  productSlug: string;
  lineItemId: string;
};
